import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import { useSnackbar } from "notistack";
import UndoIcon from "@mui/icons-material/Undo";
import { change_case_api } from "../../DAL/adminAuth/auth";

const INITIAL_VALUES = {
  title: "",
  last_name: "",
  description: "",
  categories: [],
  status: true,
  image: null,
  imagePreview: null,
  videoURL: "",
  post_code: "",
  email: "",
  password: "",
  contact_number: "",
};

export default function ChangeCaseStatus(props) {
  const {
    applyFilters,
    clearFilters,
    selectedObject,
    userList,
    caseSStatusDATA,
    onCloseDrawer,
    get_user_list,
  } = props;
  console.log(caseSStatusDATA, "caseSStatusDATAcaseSStatusDATA");

  const [inputs, setInputs] = useState(INITIAL_VALUES);
  const [submitting, setSubmitting] = useState(false);
  const [selectedAdvisorId, setSelectedAdvisorId] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const STATES_OPTIONS = [
    "California",
    "Texas",
    "New York",
    "Florida",
    "Illinois",
  ];

  const advisors = [
    { id: 1, name: "Open" },
    { id: 2, name: "Closed" },
    { id: 3, name: "Failed" },
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    const result = await change_case_api(
      caseSStatusDATA._id,
      selectedAdvisorId
    );
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      onCloseDrawer();
      get_user_list();
      setSelectedAdvisorId("");
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setSubmitting(false);
  };
  useEffect(() => {
    if (caseSStatusDATA?.status) {
      setSelectedAdvisorId(caseSStatusDATA?.status);
    }
  }, [caseSStatusDATA]);

  return (
    <form onSubmit={applyFilters} className="">
      <FormControl fullWidth margin="normal">
        <InputLabel id="advisor-select-label">Status</InputLabel>
        <Select
          labelId="advisor-select-label"
          id="advisor-select"
          value={selectedAdvisorId}
          onChange={(e) => setSelectedAdvisorId(e.target.value)}
          label="Status"
        >
          <MenuItem value="pending">Pending</MenuItem>

          <MenuItem value="recovered">Recovered</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
          <MenuItem value="assigned">Assigned</MenuItem>
        </Select>
      </FormControl>

      <div className="text-end mt-2">
        <Button
          disabled={submitting}
          variant="contained"
          onClick={handleSubmit}
        >
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </form>
  );
}
